export class FiltroReprogramacion{
    IdAdqui : string = '';
    Moneda : number = 0;
    Estado : number = 0;
    FechaInicio : string = "";
    FechaFin : string = "";
}